import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
    ActivityBuildResponse,
    ActivityPageRequest,
    Project,
    ProjectBranch,
} from '../../../../core/models';
import {ProjectTransactionService} from '../../../../core/services/projectTranscation.service';
import {ProjectSidebarService} from '../../../../projectsidebar.service';
import {Subject} from "rxjs";
import {debounceTime} from "rxjs/operators";


@Component({
    selector: 'app-project-transaction-list',
    templateUrl: './project-transaction-list.page.html'
})
export class ProjectTransactionListPage implements OnInit {
    @Input() project: Project;
    @Input() branch: ProjectBranch;



    searchTerms = new Subject<ActivityPageRequest>();
    loading = false;

    @Input() query = new ActivityPageRequest();
    activityResponse = new ActivityBuildResponse();


    constructor(
        private route: ActivatedRoute,
        private projectTransactionService: ProjectTransactionService,
        private projectSidebarService: ProjectSidebarService,
    ) {
    }

    ngOnInit() {
        this.loading = true;

        this.route.parent.params.subscribe((params) => {
            this.project.id = params.id;
        });

        this.route.parent.data.subscribe((data) => {
            if (data.project) {
                this.project = Object.assign({}, data.project);
                this.projectSidebarService.setProject(this.project);
                this.query.projectId = this.project.id;

                this.searchTerms.pipe(debounceTime(500)).subscribe(
                    (query) => {
                        this.loadActivities(query);
                    }
                );
            }
            this.loading = false;
        });
    }

    paginateActivities(event) {
        this.query.page = (event.first / event.rows) + 1;
        this.query.sortField = event.sortField !== undefined ? event.sortField : 'creationDate';
        this.query.sortDir = event.sortOrder !== undefined ? this.query.getSortDir(event.sortOrder) : 'desc';
        this.loadActivities(this.query);
    }

    search(query: ActivityPageRequest): void {
        this.searchTerms.next(query);
    }

    loadActivities(query: ActivityPageRequest) {
        this.projectTransactionService.getBranchTransaction(this.branch.id, query).subscribe(
            (data) => {
                this.activityResponse = data;
            }
        );
    }
}
